/** @jsx CanvaSX */
import { CanvaSX } from '@lib/canvasx/canvasx';
import { FlexRow } from '@lib/canvasx/components/FlexRow';
import { SPACER_3 } from '../utils/style';
import { FlexColumn } from '@lib/canvasx/components/FlexColumn';
import { Rect } from '@lib/canvasx/components/Rect';

const CONTROL_SIZE = 10;

export const BrowserStatusBar: CanvaSXComponent = function (props) {
  const { x, y, width, height } = props;

  return (
    <FlexColumn
      x={x}
      y={y}
      fill={'#F5F5F5'}
      borderRadius={{ topLeft: 8, topRight: 8 }}
      width={width}
      height={height}
    >
      <FlexRow
        width={props.width}
        height={props.height}
        borderRadius={{ topLeft: 8, topRight: 8 }}
        padding={{ top: 20, bottom: 20, left: 26 }}
        gap={SPACER_3}
      >
        <Rect
          width={CONTROL_SIZE}
          height={CONTROL_SIZE}
          fill={{ color: '#D6D6D6', opacity: 0.5 }}
          border={'#BFBFBF'}
          borderRadius={CONTROL_SIZE}
        />
        <Rect
          width={CONTROL_SIZE}
          height={CONTROL_SIZE}
          fill={{ color: '#D6D6D6', opacity: 0.5 }}
          border={'#BFBFBF'}
          borderRadius={CONTROL_SIZE}
        />
        <Rect
          width={CONTROL_SIZE}
          height={CONTROL_SIZE}
          fill={{ color: '#D6D6D6', opacity: 0.5 }}
          border={'#BFBFBF'}
          borderRadius={CONTROL_SIZE}
        />
      </FlexRow>
    </FlexColumn>
  );
};
